import { GRID_UNIT_PX } from '@/constants';

function transformToCoord(path) {
  return path.map((coord) => coord.split(':').map((value) => Number(value)));
}

function addNodes(graph, rowCount, columnCount) {
  for (let i = 0; i <= rowCount; i += 1) {
    for (let j = 0; j <= columnCount; j += 1) {
      // 過濾上下左右可以走的點
      const nodesReachable = [
        `${GRID_UNIT_PX * j}:${GRID_UNIT_PX * (i - 1)}`,
        `${GRID_UNIT_PX * j}:${GRID_UNIT_PX * (i + 1)}`,
        `${GRID_UNIT_PX * (j - 1)}:${GRID_UNIT_PX * i}`,
        `${GRID_UNIT_PX * (j + 1)}:${GRID_UNIT_PX * i}`,
      ]
        .filter((coord) => !coord.includes('-'))
        .reduce((acc, coord) => {
          acc[coord] = 1;
          return acc;
        }, {});
      graph.addNode(`${GRID_UNIT_PX * j}:${GRID_UNIT_PX * i}`, nodesReachable);
    }
  }
}

function removeNodes(graph, coordsProhibited) {
  coordsProhibited.forEach((coord) => {
    graph.removeNode(coord);
  });
}

function findShortestPath(graph, startingNode, endNode) {
  const startingKey = `${startingNode[0]}:${startingNode[1]}`;
  const endKey = `${endNode[0]}:${endNode[1]}`;

  const shortestPath = graph.path(startingKey, endKey);
  return transformToCoord(shortestPath);
}

export {
  addNodes,
  findShortestPath,
  removeNodes,
  transformToCoord,
};
